import { BodyScrollOptions } from 'body-scroll-lock'

const scrollLockOptions: BodyScrollOptions = {
	allowTouchMove: el => el instanceof Element && !!el.closest('.menu'),
}

export default scrollLockOptions
